import React from 'react';
export const FavoriteStar = ({ isFavorite, onClick }) => <a className={`f-s-ico-fav favourites-star${isFavorite ? ' on' : ''}`} onClick={onClick}/>;



// WEBPACK FOOTER //
// ./src/web-frontend-components/std/ui/FavoriteStar.jsx